module.exports = __webpack_public_path__ + "static/hero3-6b31b27e5e677036c67d799856ee0f54.png";